/**
 * ลานศิลาเก้ากระบี่, the hub: nine stone swords standing in a square. Solemn — the qin carries a slow
 * line low in 商 mode, the zheng answers from above, a temple bell marks the phrases.
 */
import { drone, vary } from '../compose';
import { registerTrack } from '../registry';

const A_QIN = `@mf 2,. 3,_ 5, 6, | 5,/- 3,\\- | 2,_ 3,_ 5,_ 6,_ 1 6, | 5,~--- |
  6,. 1_ 2 1 | 6,- 5,_ 3,_ 5, | 3,_ 2,_ 1,_ 2,_ 3, 5, | 2,~---`;
const A_ZHENG = `@mp 0--- | 0- 2'_ 1'_ 6~ | 0--- | 0- 6_ 5_ 3\\ | 0--- | 0- 1'_ 2'_ 3' | 0--- | 2'g-- 0`;
const ROOTS_A = `2, 5,, 2, 5,, 6,, 3,, 1, 2,`;

const B_ZHENG = `@mf 5g. 6_ 1' 2' | 3'%-- 2'_ 1'_ | 2'. 1'_ 6 5~ | 6%--- |
  1'. 2'_ 1'_ 6_ 5 | 3_ 5_ 6_ 1'_ 2'/- | 1'_ 6_ 5_ 3_ 2 3 | 2%---`;
const B_XIAO = `@p 2--- | 1--- | 6,--- | 2--- ; | 3--- | 5--- | 3--- | 2---`;
const B_QIN = `@mp 2,,&6,,-- 0 | 5,,&2,-- 0 | 6,,&3,-- 0 | 2,,&6,,-- 0 | 3,,&6,,-- 0 | 5,,&2,-- 0 | 1,&5,-- 0 | 2,,&6,,~---`;
const ROOTS_B = `2, 1, 2, 6,, 3,, 5,, 1, 2,`;

const BELL = `B--- | 0--- | 0--- | 0-- Dp | B--- | 0--- | 0--- | 0-- Dp`;

registerTrack({
  id: 'hub',
  order: 4,
  title: 'เก้ากระบี่ใต้ฟ้าเดียวกัน',
  mood: 'สง่า เคร่งขรึม ศักดิ์สิทธิ์',
  use: 'ลานศิลาเก้ากระบี่ (เมืองศูนย์กลาง)',
  key: 'C',
  mode: 'shang',
  bpm: 60,
  meter: 4,
  seed: 404,
  parts: {
    qin: { inst: 'qin', pan: -0.1, reverb: 0.45 },
    zheng: { inst: 'zheng', gain: 0.85, pan: 0.2, reverb: 0.4 },
    xiao: { inst: 'xiao', gain: 0.8, pan: -0.25, reverb: 0.5 },
    pad: { inst: 'pad', gain: 0.9, reverb: 0.5 },
    temple: { inst: 'perc', gain: 0.4, reverb: 0.6 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { qin: A_QIN, zheng: A_ZHENG, pad: drone(ROOTS_A, 4), temple: BELL },
    },
    B: {
      bars: 8,
      parts: { zheng: B_ZHENG, xiao: B_XIAO, qin: B_QIN, pad: drone(ROOTS_B, 4), temple: BELL },
    },
    A2: {
      bars: 8,
      parts: {
        qin: vary(A_QIN, 6, `3,_ 5,_ 6,_ 5,_ 3, 1,`),
        zheng: A_ZHENG,
        xiao: `@pp 0--- | 0--- | 0--- | 0--- | 6,--- | 1--- | 3--- | 2---`,
        pad: drone(ROOTS_A, 4),
        temple: BELL,
      },
    },
  },
  form: ['A', 'B', 'A2', 'B'],
  loop: true,
});
